
<main>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input type="search" class="form-control" #filter (keyup)="searchMember($event)"
                    placeholder="સભ્યો શોધો.." />
                <i class="ti ti-search"></i>
            </form>
            <i class="ti ti-filter cursorClass" (click)="openBottomSheet()"></i>
            <a class="ti ti-refresh cursorClass" (click)="getAllMember()"></a>
        </div>
    </div>
    <div class="d-flex justify-content-between">
        <div><strong>Total Family Member:</strong> {{memberList1}}</div>
        <div style="width: 50%;">
            <select class="form-control" (change)="onDistrict_Id($event)">
                <option hidden value="" disabled selected>જિલ્લો</option>
                <option value="" selected>All</option>
                <option *ngFor="let district of dataDistrictList" [value]="district.district_id">
                    {{district.district_name}}</option>
            </select>
        </div>
    </div>

    <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="center">
        <mat-tab label="કુટુંબના બધા સભ્યોની યાદી">
            <div class="main-members family-tabs" *ngIf="MemberList">
                <a *ngFor="let member of MemberList" class="member-list-item">
                    <!-- <div class="member-list-item"> -->
                    <ng-container [ngSwitch]="member.image !== ''">
                        <img *ngSwitchCase="true" [src]="baseUrl + member.image" />
                        <img *ngSwitchCase="false" src="../../../assets/img/user_.jpg" />
                    </ng-container>
                    <div>
                        <h5>{{ member.name }}</h5>
                        <p>{{ member.contact_no}}</p>
                        <p>{{member.business}}
                            <span *ngIf="member.business && member.village_name"> | </span>
                            {{member.village_name}}
                        </p>
                        <!-- </div> -->
                    </div>
                    <span *ngIf="member.is_verified === 0">
                        <!-- <i class="ti ti-check" (click)="Checkactive(member)"></i> -->
                    </span>
                </a>
            </div>
            <div class="main-members family-tabs" *ngIf="memberList1 == '0'">
                <p style="color: red; font-size: 30px; text-align: center;">No Data Found!</p>
            </div>
        </mat-tab>
    </mat-tab-group>
</main>